export default function MySQL_CREATEINDEX() {
  return (
    <div>
      <h2>MySQL_CREATEINDEX</h2>    </div>
  );
}